import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Qs from 'qs';

import {
  PaymentTabNav,
  PaymentTableGrid,
  SearchBar,
} from 'src/components/base/core/Grids/InvoiceGridElements';
import { PaginationLoader } from 'src/components/base/core/Grids/InvoiceGridElements/PaymentGrid/PaymentTableGrid/PaymentTableGrid.style';

import GridProvider from 'src/contexts/gridContext';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { getSearchParams } from 'src/helpers/helperSearchParams';
import {
  Header,
  HeaderFixed,
  WrpperAuthorizedContainer,
  EmptyList,
  Wrapper,
} from 'src/components/base/core';
import { handleBatches } from 'src/helpers/containers/helperBatches';

const enableSearchAndFilteringOnTrans = true;

export const BatchesPaidContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const [
    offset,
    pageCount,
    showLoader,
    searchInProgress,
    handleShowMore,
    rowCount,
    handleRowCountChange,
    tranData,
    decimalAmount,
    payout_amount,
    handleSearch,
    handleDataSorting,
    handleApplyFilter,
    handleFilterOpen,
    handleFilterClose,
    handleFilterReset,
    filterStates,
    setSelectedFilterOptions,
    selectedFilterOptions,
    setFilterAmountRange,
    resetFilter,
    setSelectedDateFilterOptions,
    selectedDateFilters,
    minmumAmount,
    maximumAmount,
    searchText,
    handleResetSearch,
    onDateChange,
    selectedDateRange,
    filterAllCount,
    setSelectedDateRange,
    setAllSelect,
    isAllSelect,
    totalInvoices,
    filterStatus,
    filteringApplied,
    filterSearchParams,
    setResetFilter,
    enableQuerySearch,
    savedMinmumAmount,
    savedMaximumAmount,
    downloadStates,
    setDownloadStates,
  ] = handleBatches('paid');

  const getUrlParams = () => {
    if (location?.search) {
      return {
        ...Qs.parse(location.search.substring(1)),
        pagination: { offset, rowCount },
      };
    }

    return {
      pagination: { offset, rowCount },
    };
  };

  useEffect(() => {
    if (filteringApplied) {
      navigate(
        {
          pathname: '/batches/paid',
          search: `?${createSearchParams(getSearchParams(filterSearchParams))}`,
        },
        { replace: true }
      );
    }
  }, [filterSearchParams]);

  useEffect(() => {
    if (filteringApplied) {
      localStorage.setItem('ear-min', minmumAmount);
      localStorage.setItem('ear-max', maximumAmount);
    }
  }, [filteringApplied]);

  useEffect(() => {
    navigate(
      {
        pathname: '/batches/paid',
        search: `?${createSearchParams(getSearchParams(getUrlParams()))}`,
      },
      { replace: true }
    );
  }, [offset, rowCount]);

  useEffect(() => {
    if (resetFilter) {
      navigate({ pathname: '/batches/paid' }, { replace: true });
      setResetFilter(!resetFilter);
    }
  }, [resetFilter]);

  return (
    <>
      <HeaderFixed className="fixed_only_desktop">
        <Header
          isMainMunuVisible
          isBackButtonVisible={false}
          isBackButtonHide
          paddingX={0}
          headerText={t('earning.headerText')}
          withCenteredHeaderText
        />
      </HeaderFixed>
      {/** Tab navigation */}
      <PaymentTabNav isInvoices={false} />
      <Wrapper isAuthorizedWrapper isTabNavigationAvailable>
        <WrpperAuthorizedContainer>
          {/** Data grid */}
          {(tranData && tranData?.length > 0) || searchInProgress || enableQuerySearch ? (
            <>
              {enableSearchAndFilteringOnTrans && (
                <SearchBar
                  isTransactions
                  onchangeHandler={handleSearch}
                  onClickEnableFilter={handleFilterOpen}
                  isSearchIconVisible={searchText === '' || searchText === undefined}
                  onResetSearch={handleResetSearch}
                  searchText={searchText}
                  filterCounterValue={filterAllCount}
                  tabType="paid"
                  isInvoicesActiveInSearchBar={false}
                  showFilterBar={true}
                  onClickDownloadCSV={() =>
                    setDownloadStates({
                      ...downloadStates,
                      isDownloadEnable: true,
                    })
                  }
                  t={t}
                />
              )}
              <GridProvider
                accordion={{
                  activeAccordion: true,
                  activeAccordionOld: null,
                  enableAccordion: false,
                  isOldInvoice: false,
                  showMoreInprogressOld: false,
                }}
                filterStatus={filterStatus}
              >
                <PaymentTableGrid
                  handleShowMore={(value: any) => handleShowMore(value)}
                  selectedRowCount={rowCount}
                  onRowCountChange={(val) => handleRowCountChange(val)}
                  dataObject={tranData}
                  paginationDisplayCondition={tranData && pageCount >= 1}
                  offset={offset}
                  pageCount={pageCount}
                  tabType="paid"
                  showLoader={showLoader}
                  onModalClose={handleFilterClose}
                  handleDataSorting={handleDataSorting}
                  onClickApplyFilter={handleApplyFilter}
                  selectedSortingOption={filterStates.sort}
                  setSelectedFilterOptions={setSelectedFilterOptions}
                  onFilterReset={handleFilterReset}
                  setFilterAmountRange={setFilterAmountRange}
                  selectedFilterOptions={selectedFilterOptions}
                  setSelectedDateFilterOptions={setSelectedDateFilterOptions}
                  selectedDateFilters={selectedDateFilters}
                  resetFilter={resetFilter}
                  minmumAmount={minmumAmount}
                  maximumAmount={maximumAmount}
                  onDateChange={onDateChange}
                  selectedDateRange={selectedDateRange}
                  isFilterEnable={filterStates && filterStates.isFilterEnable}
                  setSelectedDateRange={setSelectedDateRange}
                  setAllSelect={setAllSelect}
                  isAllSelect={isAllSelect}
                  isSelectTagVisible={false}
                  isAccordion={true}
                  accordionHeading={t('batches.tabHeading.tabThree')}
                  isAccordionArrowVisible={false}
                  isTooltipInfoEnabled={false}
                  dataCount={totalInvoices}
                  savedMinmumAmount={savedMinmumAmount}
                  savedMaximumAmount={savedMaximumAmount}
                  iconArrowVisible={true}
                  downloadStates={downloadStates}
                  setDownloadStates={setDownloadStates}
                  isTransactionGrid
                  searchText={searchText}
                />
              </GridProvider>
            </>
          ) : tranData?.length === 0 && !searchInProgress ? (
            <EmptyList
              heading={t('batches.emptyState.thirdTabHeading')}
              subHeading={t('batches.emptyState.thirdTabContent')}
              tabType="paid"
              isInvoicesTab={false}
              t={t}
            />
          ) : (
            ''
          )}

          {/** Loader */}
          {tranData === undefined && <PaginationLoader />}
        </WrpperAuthorizedContainer>
      </Wrapper>
    </>
  );
};
